
export const fontSize = 14;

export const typography = {
  fontSize,
  htmlFontSize: 16,
  fontFamily: "Nunito, sans-serif",
  body1: { fontSize },
  body2: { fontSize },
};
